import script from "./DemandCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemandCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./DemandCalendar.vue?vue&type=style&index=0&id=67a2a3fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a2a3fa"]])

export default __exports__